export enum CampaignStatus {
  notStarted = 'not started',
  inFlight = 'in flight',
  complete = 'complete'
}

export enum ArchiveStatus {
  active = 'active',
  archived = 'archived'
}
